import { CREATE_TASK, OPEN_NEW_TASK_FORM, OPEN_EDIT_TASK_FORM, CLOSE_TASK_FORM, actionCreators } from './action';

const initialState = {
    isFormIsOpen: false,
    isEditFormIsOpen: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_EDIT_TASK_FORM: 
      return {...state, isEditFormIsOpen: true, isFormIsOpen: false, initialForm: action.payload }
    case CLOSE_TASK_FORM:
      return {...state, isEditFormIsOpen: false, isFormIsOpen: false }
    case OPEN_NEW_TASK_FORM:
        return {...state, isFormIsOpen: !state.isFormIsOpen, isEditFormIsOpen: false }
    default: {
      return state;
    }
  }
};

export default reducer;
